<template>
  <div>
    <div class="bg-white  overflow-hidden sm:rounded-t-2xl sm:rounded-br-2xl border-vectric border-4">
      <ul>
        <li
          v-for="(topic, idx) in topics"
          :key="idx"
          v-bind:class="{ 'border-t border-gray-200': idx > 0 }"
        >
          <topic-table-row :topic="topic"></topic-table-row>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { topicsCollection } from "../utils/firebase";
import TopicTableRow from "./TopicTableRow";

export default {
  name: "TopicTable",
  components: { TopicTableRow },
  data() {
    return {
      topics: [],
      unapproved: [],
      unsubscribe: null
    };
  },
  created() {
    this.unsubscribe = this.fetchTopics();
  },
  beforeDestroy() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  },
  methods: {
    fetchTopics() {
      this.topics = [];
      const subscription = topicsCollection
        .where("approved", "==", true)
        .orderBy("timestamp", "desc")
        .onSnapshot(querySnapshot => {
          this.topics = [];
          querySnapshot.forEach(doc => {
            this.topics.push({ id: doc.id, ...doc.data() });
          });
        });
      return subscription;
    }
  }
};
</script>

<style scoped></style>
